import { type IValidatedResponse, putRequest } from '../../httpClient';
import type { IRateMovieV1Request } from './rate-movie-v1-request';
import { type IRateMovieV1Response, rateMovieV1ResponseSchema } from './rate-movie-v1-response';

export async function rateMovieV1Api({
  collectionId,
  ...body
}: IRateMovieV1Request): Promise<IValidatedResponse<IRateMovieV1Response>> {
  return putRequest<IRateMovieV1Response>({
    path: `/user-collections/${collectionId}/rating/v1`,
    body,
    schema: rateMovieV1ResponseSchema,
  });
}
